module.exports = __webpack_public_path__ + "img/Group 22.4c04601c.svg";